module.exports = __webpack_public_path__ + "img/betterstack.d257bd21.svg";